/**
 * LiveMeetingBadge - ambient "Live Meeting in progress" indicator in the app header.
 *
 * Reads session state from LiveMeetingSessionContext (established by
 * LiveMeetingNotificationProvider). Returns null when no meeting is active
 * or when the user is already on the live meeting page.
 *
 * Clicking opens the live meeting page in a new tab.
 */

import { ZoomIcon } from '@protoss/ui';
import { useWorkspace } from '../../../contexts/WorkspaceContext';
import { useLiveMeetingSessionContext } from '../contexts/LiveMeetingSessionContext';

export function LiveMeetingBadge() {
  const session = useLiveMeetingSessionContext();
  const { activeModule } = useWorkspace();

  if (session?.status !== 'active') return null;

  const isZoom = session.zoomMeetingUuid != null;

  const handleClick = () => {
    const sessionParam = session.sessionUuid
      ? `?session=${encodeURIComponent(session.sessionUuid)}`
      : '';
    const path = activeModule?.urlToken
      ? `/${activeModule.urlToken}/meeting/live${sessionParam}`
      : `/meeting/live${sessionParam}`;
    window.open(path, '_blank', 'noopener,noreferrer');
  };

  return (
    <button
      type="button"
      className={`lm-header-badge${isZoom ? ' lm-header-badge--zoom' : ''}`}
      onClick={handleClick}
      aria-label="Live meeting in progress – click to open"
    >
      {isZoom ? (
        <ZoomIcon size={14} className="lm-header-badge__icon" />
      ) : (
        <span className="lm-header-badge__dot" aria-hidden="true" />
      )}
      Live meeting
    </button>
  );
}
